import React, { useMemo } from 'react';
import { Box, Breadcrumbs as MuiBreadCrumbs, Typography } from '@mui/material';
import { MuiRouterLink } from 'c-components';
import { useCommonTranslation } from 'c-translation';
import type { BreadCrumbPart } from '../../Types';
import generateBreadcrumbId from './generateBreadcrumbId';

type Props = { breadcrumbs: BreadCrumbPart[] };

const BreadcrumbList: React.FC<Props> = ({ breadcrumbs }) => {
    const navLabel = useCommonTranslation('Navigation.breadcrumbsLabel');
    const linkCount = useMemo(
        () => breadcrumbs.filter(crumb => crumb.link != null).length,
        [breadcrumbs],
    );

    if (linkCount === 0) {
        return null;
    }
    return (
        <Box>
            <MuiBreadCrumbs aria-label={navLabel}>
                {breadcrumbs.map(({ link, label, id }) => {
                    if (link) {
                        const generatedId = id || generateBreadcrumbId(link);
                        return (
                            <Typography
                                key={`${link}-${label}`}
                                color="textSecondary"
                                variant="caption"
                                sx={{ fontSize: '0.78rem' }}
                            >
                                <MuiRouterLink to={link} color="inherit" id={generatedId}>
                                    {label}
                                </MuiRouterLink>
                            </Typography>
                        );
                    }
                    return (
                        <Typography
                            key={`${link}-${label}`}
                            color="textSecondary"
                            variant="caption"
                            sx={{ fontSize: '0.78rem' }}
                            id={id}
                        >
                            {label}
                        </Typography>
                    );
                })}
            </MuiBreadCrumbs>
        </Box>
    );
};

export default BreadcrumbList;
